import { WARNING_PERCENT } from './constants';
import type { RiskLevel } from './types';

/**
 * Three-tier SLA classification used by the Workforce Console — drives card
 * tints, KPI strip filters, and per-agent breached/at-risk counts.
 *
 *   - `breached`  → API or compute says the SLA is breached
 *   - `warning`   → at or past `WARNING_PERCENT` of the SLA window
 *   - `healthy`   → otherwise
 *
 * Pure function — extracted from the container so it can be unit-tested
 * without rendering React.
 */
export function deriveRiskLevel(opts: {
  isBreached: boolean;
  percentageElapsed: number;
}): RiskLevel {
  if (opts.isBreached) return 'breached';
  if (opts.percentageElapsed >= WARNING_PERCENT) return 'warning';
  return 'healthy';
}
